var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Site } from '@debbie/common/dist';
import { BlameLogRefType, BlameLogType } from '@debbie/common/dist/blamelog';
import { AlternativeContactType, PrivateStarCycle, } from '@debbie/common/dist/customers';
import { c } from '@debbie/cortex/dist';
import { blameLogs } from '@debbie/cortex/dist/api';
import * as customersAPI from '@debbie/cortex/dist/api/customers';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
import THEME from '../../theme';
import AllLanguagesInput from '../AllLanguagesInput';
import Badge from '../Badge';
import ExclusiveContent from '../ExclusiveContent';
import { Row, Col } from '../Grid';
import Select from '../Select';
import UserAddress from './UserEntites/UserAddress';
import UserBirthdate from './UserEntites/UserBirthdate';
import UserCarRegistrationNumber from './UserEntites/UserCarRegistrationNumber';
import UserCompanies from './UserEntites/UserCompanies';
import UserCompanyRelations from './UserEntites/UserCompanyRelations';
import UserCourt from './UserEntites/UserCourt';
import UserEmail from './UserEntites/UserEmail';
import UserInfoEntity from './UserEntites/UserInfoEntity';
import UserPhone from './UserEntites/UserPhone';
import UserRkiRegistrations from './UserEntites/UserRkiRegistrations';
import UserInfoHeader from './UserInfoHeader';
import { AlignLeft } from '../Icons';
const UserInfo = (props) => {
    var _a, _b, _c, _d, _e;
    const { user, customer } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const tenant = useSelector(selectTenant);
    const tenantId = useSelector(selectTenantId);
    const details = props.user.details;
    const [showDescription, setShowDescription] = useState(!!details.description);
    useEffect(() => {
        if (tenantId && !tenant) {
            c.tenants.get(tenantId);
        }
    }, [tenantId]);
    if (!tenantId)
        return null;
    const patchUser = (details, blameLog) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield customersAPI.patchUser(customer.customerId, user.userId, {
                details: details,
            });
            yield c.customers.getById(customer.customerId);
            if (blameLog) {
                const _blameLog = {
                    details: blameLog.details,
                    refId: user.userId,
                    refType: BlameLogRefType.UserOnCustomer,
                    type: blameLog.type,
                };
                yield blameLogs.createBlameLog(_blameLog, tenantId);
            }
        }
        catch (error) {
            console.error(error);
            alert('Error');
        }
    });
    return (React.createElement(UserInfoStyled, { onClick: (e) => {
            e.stopPropagation();
        } },
        !showDescription && (React.createElement("div", { style: {
                float: 'right',
                cursor: 'pointer',
                color: THEME.COLOR_ACCENT,
                fontSize: '0.7em',
                fontWeight: 'bold',
            }, onClick: () => {
                setShowDescription(!showDescription);
            } },
            lang.debtorInfo.addDescription,
            ' ',
            React.createElement(AlignLeft, { style: { margin: '0.2em 0 -0.2em 0' } }))),
        React.createElement(UserInfoHeader, { user: user, customer: customer }),
        details && (React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                details.movedAbroad &&
                    details.movedAbroad[0] &&
                    ((_a = details.status) === null || _a === void 0 ? void 0 : _a.stage) === PrivateStarCycle.GoneAway && (React.createElement("p", null,
                    React.createElement(Badge, { theme: '#000' },
                        React.createElement("b", null,
                            lang.debtorInfo.movedTo,
                            ":",
                            ' ',
                            details.movedAbroad.join(', '))))),
                React.createElement("br", null),
                React.createElement(AllLanguagesInput, { disabled: site !== Site.Caseworker, language: user.lang, onChange: (lang) => __awaiter(void 0, void 0, void 0, function* () {
                        yield customersAPI.patchUser(customer.customerId, user.userId, {
                            lang,
                        });
                        yield c.customers.getById(customer.customerId);
                    }) }),
                React.createElement("br", null),
                details.type && (React.createElement(Select, { value: details.type, onChange: (e) => patchUser({
                        type: e.target.value,
                    }) }, Object.values(AlternativeContactType).map((type) => (React.createElement("option", { key: type, value: type }, lang.alternativeContactTypes[type]))))),
                showDescription && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.description, value: details.description, hist: details.descriptionHist, onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                        const trimmedDescription = val.trim().replace(/\s\s+/g, ' ');
                        yield patchUser({
                            description: trimmedDescription || null,
                        });
                    }) })),
                React.createElement(UserInfoEntity, { title: lang.debtorInfo.name, value: details.name, hist: details.nameHist, onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                        const trimmedName = val.trim().replace(/\s\s+/g, ' ');
                        yield patchUser({
                            name: trimmedName,
                        }, {
                            details: trimmedName,
                            type: BlameLogType.DebtorUpdateName,
                        });
                    }) }),
                React.createElement(UserEmail, { user: user, patchUser: patchUser }),
                React.createElement(UserPhone, { user: user, patchUser: patchUser }),
                React.createElement(UserAddress, { user: user, patchUser: patchUser }),
                user.relation === 'alternative-contact' && (React.createElement(UserInfoEntity, { title: lang.customers.alternativeContactReferenceId, value: details.alternativeContactReferenceId, onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                        const trimmedId = val.trim().replace(/\s\s+/g, ' ');
                        yield patchUser({
                            alternativeContactReferenceId: trimmedId || null,
                        });
                    }) })),
                ((_b = details.guardian) === null || _b === void 0 ? void 0 : _b.status) && details.guardian.name && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.guardianName, value: details.guardian.name })),
                ((_c = details.guardian) === null || _c === void 0 ? void 0 : _c.status) && details.guardian.address && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.guardianAddress, value: details.guardian.address })),
                ((_d = details.guardian) === null || _d === void 0 ? void 0 : _d.status) && details.guardian.startDate && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.guardianStartDate, value: details.guardian.startDate })),
                React.createElement(ExclusiveContent, null,
                    React.createElement(UserCarRegistrationNumber, { user: user, patchUser: patchUser })),
                React.createElement(UserCourt, { user: user, patchUser: patchUser }),
                React.createElement(UserBirthdate, { customer: customer, user: user, patchUser: patchUser }),
                customer.isCompany && user.relation !== 'alternative-contact' && (React.createElement(UserInfoEntity, { title: "CVR", value: details.cvr, onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                        yield patchUser({
                            cvr: val || null,
                        }, {
                            details: val || null,
                            type: BlameLogType.DebtorUpdateCVR,
                        });
                    }) })),
                !customer.isCompany && user.relation !== 'alternative-contact' && (React.createElement(UserInfoEntity, { title: "CPR", value: details.cpr, onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                        yield patchUser({
                            cpr: val || null,
                        }, {
                            details: val || null,
                            type: BlameLogType.DebtorUpdateCPR,
                        });
                    }) })),
                !customer.isCompany && details.status && details.status.stage && (React.createElement(UserInfoEntity, { title: "CPR-status", value: lang.debtorInfo.status[details.status.stage], hist: details.statusHist, renderValue: (val) => {
                        return val && val.stage
                            ? lang.debtorInfo.status[val.stage]
                            : details.status &&
                                lang.debtorInfo.status[details.status.stage];
                    } })),
                details.ean && React.createElement(UserInfoEntity, { title: "EAN", value: details.ean }),
                details.virksomhedsform && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.companyForm, value: details.virksomhedsform })),
                details.industry && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.industry, value: details.industry })),
                details.employees && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.employees, value: details.employees })),
                customer.isCompany && !details.status && details.companyStatus && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.companyStatus, value: details.companyStatus, hist: details.companyStatusHist })),
                customer.isCompany &&
                    !details.status &&
                    !details.companyStatus && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.companyStatus, value: details.aksKOBStatusInitial &&
                        lang.debtorInfo.status[details.aksKOBStatusInitial], hist: details.aksKOBStatusInitialHist })),
                customer.isCompany && ((_e = details.status) === null || _e === void 0 ? void 0 : _e.stage) && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.companyStatus, value: lang.debtorInfo.status[details.status.stage], hist: (details.statusHist || []).concat(details.companyStatusHist ? details.companyStatusHist : []), renderValue: (val) => {
                        return val && val.stage
                            ? lang.debtorInfo.status[val.stage]
                            : typeof val === 'string'
                                ? val
                                : details.status &&
                                    lang.debtorInfo.status[details.status.stage];
                    } })),
                customer.isCompany && details.dissolvedStatuses && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.dissolutionStatus, value: lang.debtorInfo.dissolvedStatus[details.dissolvedStatuses.status], hist: details.dissolvedStatuses.data.map((status) => {
                        return {
                            value: lang.debtorInfo.dissolvedStatus[status.value],
                            source: status.source,
                            createdAt: moment(status.oploesningsStatusStartDato + ' 12:00:00', 'DDMMYYYY HH:mm:ss'),
                        };
                    }) })),
                details.website && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.website, value: details.website })),
                details.stiftelsesdato && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.dateOfFoundation, value: details.stiftelsesdato, renderValue: () => moment(details.stiftelsesdato).format(THEME.DATE_FORMAT) })),
                details.antalPenheder && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.quantifyOfPUnits, value: details.antalPenheder })),
                details.tegningsregel && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.powerToBind, value: details.tegningsregel })),
                details.reklamebeskyttet && (React.createElement(UserInfoEntity, { title: lang.debtorInfo.adProtected, value: details.reklamebeskyttet })),
                props.user.subscribedToCosmo && (React.createElement(UserRkiRegistrations, { user: user })),
                ((details.companyRelations && !!details.companyRelations.length) ||
                    (details.companies && details.companies[0])) && (React.createElement("h2", null, lang.debtorInfo.companyRelations)),
                React.createElement(UserCompanies, { companies: details.companies }),
                customer.isCompany && (React.createElement(React.Fragment, null,
                    React.createElement("br", null),
                    React.createElement(UserCompanyRelations, { companyRelations: details.companyRelations }))))))));
};
export default UserInfo;
const UserInfoStyled = styled.div `
  h3 {
    margin: 0;
    small {
      font-size: 0.7em;
      font-weight: normal;
    }

    & > span {
      font-size: 0.55em;
      font-weight: normal;

      svg {
        margin: 5px 0 -1px 0;
      }
    }
  }
  cursor: default;
`;
//# sourceMappingURL=UserInfo.js.map